import React, { Component } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { I18nProvider } from "react-aria";

import config, { mode } from "./config";
import "./App.scss";
import { Routes } from "./routes";
import className from "shared/className";

const queryClient = new QueryClient();
class App extends Component {
  render() {
    return (
      <div {...className("App", mode)}>
        <I18nProvider locale={config.locale}>
          <QueryClientProvider client={queryClient} contextSharing={true}>
            <Routes />
            <ReactQueryDevtools />
          </QueryClientProvider>
        </I18nProvider>
      </div>
    );
  }
}

export default App;
